import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem, MultiselectSettings } from '../../../core/interfaces/admin.interface';
import { MediaApiService } from '../../services/media-api.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-media-key-select',
  templateUrl: './media-key-select.component.html',
  styleUrls: ['./media-key-select.component.scss']
})
export class MediaKeySelectComponent {

  @Input() keySelected: MultiselectItem[] = [];
  @Input() keyRoot: string;
  @Input() singleSelection: boolean = null;
  @Output() keySelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  get computedSettings(): MultiselectSettings {
    if (this.singleSelection != null) {
      return { ...MULTI_SELECT_SETTING[EMULTI_SELECT_SETTING.NO_SEARCH], singleSelection: this.singleSelection };
    }
    return MULTI_SELECT_SETTING[EMULTI_SELECT_SETTING.NO_SEARCH];
  }

  keysList: MultiselectItem[] = [];

  constructor(
    private mediaApiService: MediaApiService,
  ) {
    this.loadMultiselectItems();
  }

  loadMultiselectItems(): void {

     this.mediaApiService.multiselectKeyMedia().subscribe(response => {

      const { data } = response;

      if (data) {
        this.keysList = (data as any[]).filter(key => (this.keyRoot ? (key.name as string).startsWith(this.keyRoot) : true)).map(key => {
          return {
            id: key.id,
            itemName: key.name
          } as MultiselectItem
        })
      }

    });
  }

  onKeyChange(): void {
    this.keySelectedChange.emit(this.keySelected);
    this.onSelected.emit(this.keySelected);
  }

}
